import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { apiRequest } from '../config/authConfig';

const useAuthenticatedFetch = () => {
  const { instance, accounts } = useMsal();

  const authenticatedFetch = useCallback(async (url, options = {}) => {
    try {
      const account = instance.getActiveAccount() || accounts[0];
      const request = {
        ...apiRequest,
        account,
      };

      const response = await instance.acquireTokenSilent(request);

      const headers = {
        ...(options.headers || {}),
        Authorization: `Bearer ${response.accessToken}`,
      };

      if (options.body instanceof FormData) {
        delete headers['Content-Type'];
        delete headers['content-type'];
      } else if (!('Content-Type' in headers) && !('content-type' in headers)) {
        headers['Content-Type'] = 'application/json';
      }

      return fetch(url, {
        ...options,
        headers,
      });
    } catch (error) {
      console.error('Token acquisition failed:', error);

      const errorCode = String(error?.errorCode || '').toLowerCase();
      const isInteractionRequired =
        error instanceof InteractionRequiredAuthError ||
        errorCode === 'interaction_required' ||
        errorCode === 'login_required' ||
        errorCode === 'consent_required';

      if (isInteractionRequired) {
        try {
          await instance.acquireTokenRedirect({
            ...apiRequest,
            account: instance.getActiveAccount() || accounts[0],
          });

          throw new Error('Authentication redirect initiated.');
        } catch (redirectError) {
          throw redirectError;
        }
      }

      throw error;
    }
  }, [instance, accounts]);

  return authenticatedFetch;
};

export default useAuthenticatedFetch;
